import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./index.css";
import { GoCheckCircle } from "react-icons/go";
import { MdClose } from "react-icons/md";
import {
  Button,
  Box,
  LinearProgress,
  FormGroup,
  FormControlLabel,
  Checkbox
} from "@mui/material"
import axios from "axios";
import { createChunks, readFile } from "../../../../utils/fileFunctions";
// import fileHash from './FileHash';
import Plot from "../../components/Plot";
import { useCookies } from "react-cookie";
import FileUploadDrag from "../../components/FileUploadDrag";
import TextInput from "./TextInput";

export default function FileUploadTestModel(props) {
  const navigate = useNavigate();
  const [cookies, setCookie] = useCookies([""])

  const { model, uid, usertype, handleAlert, sampleData } = props;
  const [uploaded, setUploaded] = useState(false);
  const [files, setFiles] = useState([]);
  const [fileContents, setFileContents] = useState([])
  const [consent, setConsent] = useState(usertype === 'Internal' || usertype === 'Admin' ? false : false);
  const [sizeLimit, setSizeLimit] = useState(10);
  const [currFileSize, setCurrFileSize] = useState(0);
  const [progress, setProgress] = useState(0)
  const [showProgress, setShowProgress] = useState(false)
  const [showPlots, setShowPlots] = useState(document.cookie.includes("acceptedCookiePolicy=true") && cookies["showPlots"] !== undefined ? parseInt(cookies["showPlots"]) : 1)

  const [inputMethod, setInputMethod] = useState("upload");
  const [text, setText] = useState("");

  const successRef = useRef(null);

  const handleConsent = (e) => {
    setConsent(e.target.checked);
    setSizeLimit(e.target.checked ? 1024 : 10);
  };

  const filter_file_size = (file) => {
    if (file.size + currFileSize > sizeLimit * 1024 * 1024) {
      return false;
    } else {
      return true;
    }
  };

  const scrollToElement = (ref) => {
    ref.current.scrollIntoView({ behavior: "smooth" });
  }

  const handleUpload = async () => {
    if (currFileSize > sizeLimit * 1024 * 1024) {
      handleAlert("error", "File too big! Please remove files!", 3000);
    } else {
      setShowProgress(true)
      if (!consent) {
        // for small files
        if (files.length > 0) {
          const formData = new FormData();
          if (inputMethod === "upload") {
            for (let i = 0; i < files.length; i++) {
              formData.append("files", files[i]);
            }
          } else {
            const blob = new Blob([JSON.stringify(fileContents)], { type: "application/json" });
            console.log(blob);
            formData.append("files", blob, "input.json");
          }

          formData.append("consent", consent);
          formData.append("mid", model.id);
          formData.append("uid", uid);

          await axios({
            method: "post",
            url: `/api/m2d/models/test`,
            data: formData,
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (e) => {
              const completed = Math.round(
                (e.loaded * 100) / e.total
              )
              setProgress(completed)
            }
          });
          setShowProgress(false)
          scrollToElement(successRef)
        } else {
          handleAlert("error", "Please upload file first!", 3000);
          setShowProgress(false)
        }
      } else {
        // for big files
        const chunkSize = 10 * 1024 * 1024;
        let resultId = -1;
        // let totalChunkNum = 0
        let currFileIndex = 0
        const config = {
          onUploadProgress: (e) => {
            const completed = Math.round(
              e.loaded / e.total
            )
            setProgress(completed + currFileIndex)
          }
        }
        try {
          // for (const file in files) {
          //   totalChunkNum += Math.ceil(file.size / chunkSize);
          // }
          for (let i = 0; i < files.length; i++) {
            const chunks = createChunks(files[i], chunkSize);
            // const hash = await fileHash(chunks)
            // console.log(hash)
            for (let j = 0; j < chunks.length; j++) {
              const formData = new FormData();
              formData.append("files", chunks[j]);
              formData.append("name", files[i].name);
              formData.append("index", j);
              formData.append("total", chunks.length);
              formData.append("consent", consent);
              formData.append("fileIndex", i);
              formData.append("totalFileNumber", files.length);
              formData.append("resultId", resultId);
              formData.append("mid", model.id);
              formData.append("uid", uid);

              const result = await axios({
                method: "post",
                url: `/api/m2d/models/test`,
                data: formData,
                headers: {
                  "Content-Type": "multipart/form-data",
                }
              }, config);
              currFileIndex += 1
              if (result.data.resultId) {
                resultId = parseInt(result.data.resultId);
              }
            }
          }
        } catch (err) {
          handleAlert("error", err.message, 3500);
        }
      }

      setFiles([]);
      setCurrFileSize(0);
      setUploaded(true);
      setShowProgress(false)
    }
  };

  const handleInputFiles = async (input_files) => {
    let error_flag = false;
    let same_name_flag = false;
    let tmp = [];
    let total_file_size = currFileSize;
    for (const f of input_files) {
      if (
        f.type !== "application/json" ||
        !filter_file_size(f) ||
        input_files.length + files.length > 15
      ) {
        error_flag = true;
        break;
      } else {
        for (const file of files) {
          if (file.name === f.name) {
            same_name_flag = true;
            break;
          }
        }
        tmp.push(f);
        total_file_size += f.size;
      }
    }
    if (error_flag) {
      handleAlert(
        "error",
        `Please upload at most 15 JSON files within ${sizeLimit >= 1024 ? sizeLimit / 1024 + "GB" : sizeLimit + "MB"
        }!`,
        3500
      );
    } else if (same_name_flag) {
      handleAlert(
        "error",
        "Please do not upload two files withthe same name!",
        3000
      );
    } else {
      setFiles([...files, ...tmp]);
      let contents = await Promise.all(tmp.map(readFile));
      contents = contents.map((content) => JSON.parse(content))
      // const signals = contents
      setFileContents([...fileContents, ...contents])
      setCurrFileSize(total_file_size);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const input_files = e.dataTransfer.files;
    handleInputFiles(input_files);
  };

  const handleFileInputChange = (e) => {
    const input_files = e.target.files;
    handleInputFiles(input_files);
  };

  const handleRemoveFile = (e) => {
    const file_idx = e.currentTarget.id;
    let tmp = [...files];
    let tmpContent = [...fileContents]
    const file_size = currFileSize - files[file_idx].size;
    tmp.splice(file_idx, 1);
    tmpContent.splice(file_idx, 1)
    setFiles(tmp);
    setFileContents(tmpContent)
    setCurrFileSize(file_size);
  };

  const handleClear = () => {
    setFiles([]);
    // const fileInput = document.getElementById('file')
  };

  const handleConfirm = () => {
    if (uploaded === true) {
      setUploaded(false);
    }
  };

  const handleResult = () => {
    if (uploaded === true) {
      navigate("/m2d/history");
    }
  };

  const handlePlots = (e) => {
    const value = e.target.checked ? 1 : 0
    setShowPlots(value)
    if (document.cookie.includes("acceptedCookiePolicy=true")) {
      setCookie("showPlots", value, {
        expires: new Date(new Date().getTime + 2 * 3600 * 1000),
      });
    }
  }

  const file2content = (file, index) => {
    return (
      <div className="uploaded-file" key={index}>
        <div className="file-content">
          <div className="file-name">{file.name} (Frequency: {fileContents[index] ? parseInt(fileContents[index][0].frequency) : 0}hz)</div>
          {model.m2dModelInputType.type.includes("signal") && fileContents.length > index && showPlots ? (
            Array.isArray(fileContents[index]) ?
              fileContents[index].map((content, idx) => {
                return (
                  <Plot
                    filename={`${file.name}.json`}
                    contents={content.signal}
                    frequency={content.frequency}
                    height={70}
                    grid={0}
                    color="rgb(100, 100, 100)"
                    resultId={-1}
                    groundTruth={-1}
                    key={idx} />
                )
              })
              :
              <Plot
                filename={`${file.name}.json`}
                contents={fileContents[index].signal}
                frequency={fileContents[index].frequency}
                height={70}
                grid={0}
                color="rgb(100, 100, 100)"
                resultId={-1}
                groundTruth={-1} />
          ) : null}
        </div>

        <div
          className="delete-file-btn"
          id={index}
          onClick={handleRemoveFile}
        >
          <MdClose style={{ fontSize: 20 }} />
        </div>
      </div>
    );
  }

  const handleInputTypeChange = () => {
    if (inputMethod === "upload") {
      setInputMethod("inputbox");
    } else {
      setInputMethod("upload");
    }
    setFileContents([]);
    setFiles([]);
  };

  const handleInputChange = (value) => {
    setText(value)
    let freq_flag = false;
    let signals = value.split("\n")
    signals = signals.map((signal) => {
      let new_signal = signal.split(",");
      new_signal = new_signal.map((s) => parseFloat(s));
      const freq = parseInt(new_signal.length / 30);
      if (freq < 30) {
        freq_flag = true;
      }
      return { frequency: freq, signal: new_signal };
    });

    if (!freq_flag) {
      setFileContents([signals])
      setFiles([{ name: "input", size: 0 }])
    } else {
      setFileContents([]);
      setFiles([]);
    }

  };

  return (
    <>
      <div className="test-model-content">
        <div className={`success${uploaded ? "" : "-close"}`} ref={successRef}>
          <GoCheckCircle
            style={{
              fontSize: "60px",
              color: "rgb(0, 171, 0)",
              marginTop: "10px",
            }}
          />
          <div className="success-info">Successfully submitted!</div>
          <div className="success-sub-info">
            It may take a while before we're able to show you the results. You
            can track the progress in your account page.
          </div>
          <div className="confirm-btn-area">
            <div className="confirm-btn" onClick={handleConfirm}>
              Confirm
            </div>
            <div className="result-btn" onClick={handleResult}>
              Go to account
            </div>
          </div>
        </div>

        <div
          className={`data-not-saved-note${uploaded || consent ? "-close" : ""}`}
        >
          ⚠️Your data will NOT be saved by any means!
        </div>
        <div className={`data-info${uploaded ? "-close" : ""}`}>
          {model.dataDescription} Please see:{" "}
          <a
            className="link"
            href={`https://github.com/hulab-emory/m2d-files/blob/main/example_files/${model.exampleFile}.json`}
            download
          >
            json example
          </a>
          .
        </div>
        <div className={`file-dropbox${uploaded ? "-close" : ""}`}>
          {model.exampleFile && (
            <div className="example-plot">
              {sampleData.length > 0 && sampleData.map((data, index) =>
                <div key={index}>
                  <div className="example-plot-title">Sample signal (Frequency: {data.frequency}hz)</div>
                  <Plot
                    filename={`${model.exampleFile}.json`}
                    contents={data.signal}
                    frequency={data.frequency}
                    height={50}
                    grid={0}
                    resultId={-1}
                    groundTruth={-1}
                  />
                </div>
              )}
            </div>
          )}

          {inputMethod === "upload" ? <>
            <FileUploadDrag
              onInputChange={handleFileInputChange}
              onDrop={handleDrop}
              prompt="Support .json files only"
              currFileSize={currFileSize}
              sizeLimit={sizeLimit}
            />
            <div className={`data-saving-consent${uploaded ? "-close" : ""}`} hidden={!model.m2dModelInputType.type.includes("signal")}>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox size="small" defaultChecked={showPlots ? true : false} />}
                  onChange={handlePlots}
                  label={
                    <div className="consent-label">
                      Show plots upon upload
                    </div>
                  }
                />
              </FormGroup>
            </div>
          </> : <>
            <TextInput text={text} onChange={handleInputChange} errorMsg={text.length > 0 && fileContents.length === 0 && "Wrong frequency!"} />
          </>}
        </div>



        <div className="switch-input-btn" onClick={handleInputTypeChange}>
          {inputMethod === "upload" ? "Manually input signals" : "Upload signal files"}
        </div>

        {files.length > 0 ? (
          <div className="file-area">
            {files.map(file2content)}
          </div>
        ) : null}

        <div className={`data-saving-consent${uploaded ? "-close" : ""}`} hidden>
          <FormGroup>
            <FormControlLabel
              control={<Checkbox size="small" />}
              onChange={handleConsent}
              label={
                <div className="consent-label">
                  By checking this checkbox, you agree to give the website
                  permission to save the data you uploaded for any legal
                  usage, and you will have advanced access to more analysis
                  tools we provide.
                </div>
              }
            />
          </FormGroup>
        </div>
        {showProgress ? (
          <Box sx={{ width: '100%', marginTop: '10px' }}>
            <LinearProgress variant="determinate" value={progress} />
          </Box>
        ) : null}

        <div className={`upload-btn-area${files.length > 0 ? "" : "-close"}`}>
          <Button
            variant="contained"
            onClick={handleUpload}
            style={{ marginRight: "15px" }}
          >
            Submit
          </Button>
          <Button
            variant="outlined"
            onClick={handleClear}>
            Clear
          </Button>
        </div>
      </div>
    </>
  );
}
